// 手动字幕选区（subtitleType=manual 的 areaList）：坐标为源视频像素。
// 前端框选组件产出、ui-options 透传、adapter 组装请求共用本模块，无服务端依赖。

export type SubtitleArea = { x: number; y: number; width: number; height: number };

/** 小于该尺寸（像素）的框视为误触，丢弃 */
export const MIN_SUBTITLE_AREA_PX = 8;

/**
 * 校验并规整选区数组：过滤非法项（非有限数、负坐标、非正宽高），坐标取整。
 * 全部非法或非数组时返回 undefined（调用方按「无选区」处理）。
 */
export function sanitizeSubtitleAreas(raw: unknown): SubtitleArea[] | undefined {
    if (!Array.isArray(raw)) return undefined;
    const areas: SubtitleArea[] = [];
    for (const item of raw) {
        const x = Number((item as any)?.x);
        const y = Number((item as any)?.y);
        const width = Number((item as any)?.width);
        const height = Number((item as any)?.height);
        if (![x, y, width, height].every(Number.isFinite)) continue;
        if (x < 0 || y < 0 || width <= 0 || height <= 0) continue;
        areas.push({
            x: Math.round(x),
            y: Math.round(y),
            width: Math.round(width),
            height: Math.round(height),
        });
    }
    return areas.length > 0 ? areas : undefined;
}
